export const getEsHotelSearchHotels = (name, payload) => {
  if (
    name !== "es_hotel_search" ||
    payload?.type !== "hotel_cards" ||
    !Array.isArray(payload.hotels) ||
    payload.hotels.length === 0
  ) {
    return [];
  }

  return payload.hotels.filter(Boolean);
};
